import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { BLOG_POSTS, BLOG_CONTENT } from '../mock';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ArrowLeft, ArrowRight, CalendarDays, Clock } from 'lucide-react';

const renderMarkdown = (text) => {
  const lines = text.split('\n');
  const out = [];
  let list = null;
  lines.forEach((line, i) => {
    if (line.startsWith('## ')) {
      if (list) { out.push(list); list = null; }
      out.push(<h2 key={i}>{line.slice(3)}</h2>);
    } else if (line.startsWith('### ')) {
      if (list) { out.push(list); list = null; }
      out.push(<h3 key={i}>{line.slice(4)}</h3>);
    } else if (/^\d+\.\s/.test(line)) {
      if (!list || list.type !== 'ol') {
        if (list) out.push(list);
        list = { type: 'ol', items: [] };
      }
      list.items.push(line.replace(/^\d+\.\s/, ''));
    } else if (line.startsWith('- ')) {
      if (!list || list.type !== 'ul') {
        if (list) out.push(list);
        list = { type: 'ul', items: [] };
      }
      list.items.push(line.slice(2));
    } else if (line.trim() === '') {
      if (list) { out.push(list); list = null; }
    } else {
      if (list) { out.push(list); list = null; }
      const html = line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      out.push(<p key={i} dangerouslySetInnerHTML={{ __html: html }} />);
    }
  });
  if (list) out.push(list);
  return out.map((el, i) => {
    if (el.type === 'ul') return <ul key={`ul-${i}`}>{el.items.map((it, k) => <li key={k} dangerouslySetInnerHTML={{__html: it.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')}} />)}</ul>;
    if (el.type === 'ol') return <ol key={`ol-${i}`}>{el.items.map((it, k) => <li key={k} dangerouslySetInnerHTML={{__html: it.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')}} />)}</ol>;
    return el;
  });
};

const BlogPost = () => {
  const { slug } = useParams();
  const post = BLOG_POSTS.find(p => p.slug === slug);
  const content = BLOG_CONTENT[slug];

  if (!post) return <div className="max-w-3xl mx-auto py-20 px-4">Artikel niet gevonden. <Link to="/blog" className="text-[#f26b1f]">Terug naar blog</Link></div>;

  const related = BLOG_POSTS.filter(p => p.slug !== slug).slice(0, 3);

  return (
    <div>
      <section className="hero-gradient text-white py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <Link to="/blog" className="inline-flex items-center gap-1 text-slate-300 hover:text-white text-sm"><ArrowLeft className="w-4 h-4" /> Terug naar blog</Link>
          <Badge className="bg-[#f26b1f] text-white border-0 mt-4">{post.category}</Badge>
          <h1 className="text-3xl md:text-5xl font-bold mt-3 leading-tight">{post.title}</h1>
          <div className="flex items-center gap-4 mt-4 text-sm text-slate-300">
            <span className="flex items-center gap-1"><CalendarDays className="w-4 h-4" /> {post.date}</span>
            <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {post.readTime}</span>
            <span>door {post.author}</span>
          </div>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-4 md:px-6 py-10">
        <img src={post.image} alt={post.title} className="w-full h-72 md:h-96 object-cover rounded-xl mb-8" />
        <div className="prose-content">{renderMarkdown(content || post.excerpt)}</div>

        <Card className="mt-10 p-6 md:p-8 bg-[#1e1b4b] text-white border-0">
          <div className="font-bold text-xl">Boete ontvangen?</div>
          <p className="text-slate-300 text-sm mt-2">Wij maken gratis bezwaar. No cure, no pay.</p>
          <Link to="/indienen"><Button className="mt-4 bg-[#f26b1f] hover:bg-[#d4581a] text-white">Gratis indienen <ArrowRight className="w-4 h-4 ml-2" /></Button></Link>
        </Card>
      </article>
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
        <h3 className="text-2xl font-bold text-[#1e1b4b] mb-6">Lees meer</h3>
        <div className="grid md:grid-cols-3 gap-6">
          {related.map(p => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="card-hover">
              <Card className="overflow-hidden border border-slate-200 h-full">
                <div className="h-40 bg-slate-100"><img src={p.image} alt={p.title} className="w-full h-full object-cover" /></div>
                <div className="p-5">
                  <Badge className="bg-[#f26b1f]/10 text-[#f26b1f] border-0 hover:bg-[#f26b1f]/15">{p.category}</Badge>
                  <div className="font-bold text-[#1e1b4b] mt-3 leading-snug">{p.title}</div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
